import React from "react";

const LabelForm = (props)=>{
    return(
        <span className="span-min" style={props.styles}>{props.text}</span>
    )
}

export default LabelForm;

LabelForm.defaultProps = {
    styles:{}
}